
import { formatDate } from "@/app/infrastructures/misc/Utils";
import { SummarySTTData } from "@/domain/entities/PusatResolusiV2";
import { prop, Vue } from "vue-class-component";

class Props {
  isSummary = prop<boolean>({
    type: Boolean,
    default: false
  });
  detailData = prop<SummarySTTData>({
    type: SummarySTTData,
    required: true
  });
}

export default class DelDexCodrej extends Vue.with(Props) {
  private isCollapsed = false;

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }
  formatDateTime(date: any): string {
    return formatDate(date);
  }

  get lastStatusAt() {
    return this.formatDateTime(
      this.detailData.rejectReason ?
        this.detailData.lastDelivAt :
        this.detailData.updatedAt
    )
  }

  get isSttNumber(): boolean {
    return /^\d{1,2}LP\w+$/g.test(this.detailData.sttNo);
  }

  get decideEmptyAttempts() {
    return this.isSttNumber ? '0' : '-';
  }
}
